/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from 'react';
import { NotFoundPage } from '@vlinder-web/not-found-page-widget-react';
import { useTheme } from '@/providers/theme';
import { routes } from '@/AppNavigator/services/config/routes.config.json';

import { useNavigate } from 'react-router-dom';

import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

const getSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const navigate = useNavigate();
  // useEffect(() => {
  //   let token = getSrv()?.getToken();
  //   if (!token) {
  //     navigate(`${routes?.SignIn?.path}`);
  //   }
  // }, []);
  return (
    <NotFoundPage
    // buttonStyle={{ backgroundColor: theme?.colors?.primary }}
    />
  );
};
